"use client";
import * as React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css/navigation";
import "swiper/css/pagination";
import slider from "./Slider.module.css";

import "swiper/css";
import Link from "next/link";
import {
  useFavoriteStore,
  useShareModalStore,
  useToastStore,
} from "@/app/store/localapi";
import { useState } from "react";
import { favunfav } from "@/app/utils/favunfav";
import { useAuthStore } from "@/app/store/authstore";
import Noepisode from "./noepisode/Noepisode";
import { createSlug } from "../utils/createSlug";

export interface Drama {
  added_dt: string;
  d_desc: string;
  d_keywords: string;
  drama_name: string;
  gradient: string;
  id: string;
  image_url: string;
  slug: string;
  status: string;
  total_episodes: string;
  unlock_epi_count: string;
  launch_date?: string;
  d_name?: string;
  d_image?: string;
  d_id?: string;
  tag?: string;
}

{
  /* eslint-disable @next/next/no-img-element */
}
const Slider = ({ data }: { data: Drama[] }) => {
  const openShareModal = useShareModalStore((state) => state.openShareModal);
  const removeFavorite = useFavoriteStore((state) => state.removeFavorite);
  const addFavorite = useFavoriteStore((state) => state.addFavorite);
  const favorites = useFavoriteStore((state) => state.favorites);
  const user = useAuthStore((state) => state.user);
  const { showToast } = useToastStore();
  const [dramas, setDramas] = useState<Drama[]>([]);
  const [tags, setTags] = useState<Record<string, string>>({});
  React.useEffect(() => {
    setDramas(data);
    fetchTags();
  }, [data]);

  const fetchTags = async () => {
    try {
      const response = await fetch('https://dramasstory.com/admin/tagging_list.php');
      const data = await response.json();
      /* eslint-disable @typescript-eslint/no-explicit-any */
      const output = data.data.Data.reduce((acc: any, item: any) => {
        acc[item.id] = item.Tagging;
        return acc;
      }, {});
      setTags(output);
    } catch (error) {
      console.error('Error fetching tags:', error);
    }
  };

  const senddata = async (dramaid: string, type: string) => {
    await favunfav({
      d_id: dramaid,
      user_id: user?.user_id || "",
      type: type
    }, (msg: string) => showToast(msg, "success"))
  }

  const handleRemoveFavorite = (dramaId: string) => {
    removeFavorite(dramaId);
    if (!user) return showToast("Removed from Favorite", "info")
    senddata(dramaId, "unfavourite")
  };

  const handleAddFavorite = (drama: Drama) => {
    addFavorite({
      d_id: drama.id,
      d_title: drama.drama_name,
      d_image: drama.image_url,
      total_ep: drama.total_episodes,
      d_desc: drama.d_desc
    });
    if (!user) return showToast("Added to Favorite", "success")
    senddata(drama.id, "favourite")
  };

  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    setLoading(true);
    setDramas(data);
    setLoading(false);
  }, [data]);

  if (loading) return null;

  if (dramas.length === 0) return <Noepisode fav={false} />;

  return (
    <Swiper
      modules={[Navigation]}
      navigation
      spaceBetween={25}
      slidesPerView={5}
      onSlideChange={() => console.log("slide change")}
      onSwiper={() => console.log('')}
      breakpoints={{
        100: {
          slidesPerView: 1,
        },
        320: {
          slidesPerView: 2,
        },
        600: {
          slidesPerView: 3,
        },
        768: {
          slidesPerView: 3,
        },
        1024: {
          slidesPerView: 4,
        },
        1280: {
          slidesPerView: 5,
        },
      }}
    >
      {dramas &&
        dramas.map((item, index) => {
          const isFavorite = !!favorites[item.id];

          return (
            <SwiperSlide key={item.id || index}>
              <div className={slider.newdramaheading} style={{ backgroundColor: "rgb(35, 36, 40)" }}>
                <div className={slider.cardImg}>
                  <Link aria-label="Drama Image" href={`/drama/${createSlug(item?.drama_name)}-${item.id}/?episode=0`}>
                    <img
                      src={item?.image_url}
                      alt={item?.drama_name || "Drama Image"}
                      loading="lazy"
                      onError={(e) => { e.currentTarget.src = '/placeholder_Ig.webp'; }}
                    />
                  </Link>
                </div>
                <div className={slider.dramaContent}>
                  <div className={slider.dramacontentbody}>
                    <h3>{item?.drama_name}</h3>
                    <p>{item?.d_desc}</p>
                  </div>
                  <div className={slider.releaseBtns}>
                    <div className={slider.playbtn}>
                      <Link aria-label="drama icons and play button" href={`/drama/${createSlug(item?.drama_name)}-${item.id}/?episode=0`}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="15"
                          viewBox="0 0 16 15"
                          fill="none"
                        >
                          <circle
                            cx="8.29159"
                            cy="7.59735"
                            r="7.05087"
                            fill="#848484"
                            fillOpacity="0.5"
                            stroke="white"
                            strokeWidth="0.7"
                          />
                          <path
                            d="M10.6578 7.06138L7.45642 4.86973C7.30857 4.76845 7.15961 4.71484 7.03579 4.71484C6.79641 4.71484 6.64833 4.90696 6.64833 5.22855V9.96534C6.64833 10.2866 6.79622 10.4783 7.03504 10.4783C7.15905 10.4783 7.30563 10.4246 7.45381 10.3231L10.6567 8.13148C10.8626 7.9903 10.9767 7.80033 10.9767 7.59631C10.9768 7.39244 10.864 7.20251 10.6578 7.06138Z"
                            fill="white"
                          />
                        </svg>
                        <span>Play</span>
                      </Link>
                    </div>
                    <div className={slider.socialRelbtns}>
                      <div className={slider.socialRelbtnsSaveList}>
                        {!isFavorite ? (
                          <span onClick={() => handleAddFavorite(item)}>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="19"
                              height="19"
                              viewBox="0 0 19 19"
                              fill="none"
                            >
                              <path
                                d="M12.5221 4.36133C12.6488 4.36133 12.7607 4.4095 12.8502 4.49902L12.9098 4.57031C12.9608 4.64547 12.9879 4.73222 12.9879 4.82715C12.9879 4.92212 12.9609 5.00881 12.9098 5.08398L12.8502 5.15527L8.87268 9.13379C8.85039 9.15608 8.82603 9.17641 8.80042 9.19434L8.71838 9.23926C8.66445 9.2608 8.60752 9.27048 8.54944 9.27051C8.52017 9.27051 8.49097 9.26789 8.46252 9.2627L8.37952 9.23926C8.3504 9.22759 8.32307 9.21227 8.29749 9.19434L8.2262 9.13379L6.35608 7.26367C6.26528 7.17287 6.21838 7.05807 6.21838 6.92969C6.21841 6.80134 6.2653 6.68746 6.35608 6.59668L6.42542 6.53809C6.49936 6.48705 6.58455 6.45907 6.67834 6.45898C6.8034 6.45898 6.91335 6.50844 7.00159 6.59668L8.54846 8.14355L12.194 4.49902L12.2653 4.43945C12.3404 4.38835 12.4272 4.3614 12.5221 4.36133Z"
                                fill="white"
                                stroke="white"
                                strokeWidth="0.3"
                              />
                              <path
                                d="M4.40109 1.59863H15.323C15.9729 1.59863 16.4987 2.12453 16.4987 2.77441V16.415C16.4987 17.3585 15.4679 17.894 14.7077 17.4209L14.5603 17.3125L10.3152 13.7031L9.86203 13.3184L9.40891 13.7031L5.16379 17.3125C4.39861 17.9621 3.22531 17.4191 3.22531 16.415V2.77441C3.22531 2.16504 3.68756 1.66453 4.28098 1.60449L4.40109 1.59863Z"
                                stroke="white"
                                strokeWidth="1.4"
                              />
                            </svg>
                          </span>
                        ) : (
                          <span
                            className={slider.hideSaveListIcon}
                            onClick={() => handleRemoveFavorite(item.id)}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="19"
                              height="19"
                              viewBox="0 0 19 19"
                              fill="none"
                            >
                              <path
                                d="M4.40112 1.40723H15.323C15.9729 1.40723 16.4988 1.93312 16.4988 2.58301V16.2236C16.4988 17.1671 15.4679 17.7026 14.7078 17.2295L14.5603 17.1211L10.3152 13.5117L9.86206 13.127L9.40894 13.5117L5.16382 17.1211C4.39864 17.7707 3.22534 17.2277 3.22534 16.2236V2.58301C3.22534 1.97364 3.68759 1.47312 4.28101 1.41309L4.40112 1.40723Z"
                                fill="white"
                                stroke="white"
                                strokeWidth="1.4"
                              />
                              <path
                                d="M12.5222 4.16992C12.6489 4.16992 12.7608 4.21809 12.8503 4.30762L12.9099 4.37891C12.9609 4.45407 12.988 4.54082 12.988 4.63574C12.988 4.73072 12.961 4.81741 12.9099 4.89258L12.8503 4.96387L8.8728 8.94238C8.85051 8.96467 8.82615 8.98501 8.80054 9.00293L8.71851 9.04785C8.66457 9.0694 8.60764 9.07907 8.54956 9.0791C8.52029 9.0791 8.49109 9.07649 8.46265 9.07129L8.37964 9.04785C8.35052 9.03619 8.32319 9.02086 8.29761 9.00293L8.22632 8.94238L6.3562 7.07227C6.2654 6.98147 6.21851 6.86667 6.21851 6.73828C6.21853 6.60994 6.26543 6.49605 6.3562 6.40527L6.42554 6.34668C6.49949 6.29565 6.58467 6.26766 6.67847 6.26758C6.80352 6.26758 6.91347 6.31704 7.00171 6.40527L8.54858 7.95215L12.1941 4.30762L12.2654 4.24805C12.3405 4.19695 12.4273 4.16999 12.5222 4.16992Z"
                                fill="#0F0F0F"
                                stroke="#0F0F0F"
                                strokeWidth="0.3"
                              />
                            </svg>
                          </span>
                        )}
                      </div>
                      <span
                        onClick={() => openShareModal(item)}
                        style={{ cursor: "pointer" }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="19"
                          height="19"
                          viewBox="0 0 19 19"
                          fill="none"
                        >
                          <path
                            d="M13.7413 2.62402C15.2028 2.62422 16.4425 3.83107 16.4425 5.2959C16.4423 6.75894 15.2347 7.96672 13.7716 7.9668C12.9441 7.9668 12.1786 7.5544 11.6974 6.95801L7.13 9.25684C7.17858 9.45874 7.20422 9.67954 7.20422 9.89941C7.20422 10.1189 7.17843 10.3394 7.13 10.541L11.6954 12.8389C12.1784 12.2141 12.9463 11.832 13.7716 11.832C15.2347 11.8321 16.4423 13.0399 16.4425 14.5029C16.4425 15.9662 15.2348 17.1747 13.7716 17.1748C12.3083 17.1748 11.1007 15.9662 11.1007 14.5029C11.1007 14.2834 11.1255 14.0629 11.174 13.8613L6.60754 11.5635C6.12456 12.1879 5.35834 12.5703 4.53333 12.5703C3.07175 12.5703 1.83118 11.3644 1.83118 9.89941C1.83118 8.43614 3.03978 7.22852 4.50305 7.22852C5.32997 7.22865 6.09416 7.64059 6.57532 8.23633L11.1427 5.9375C11.0943 5.73595 11.0695 5.51532 11.0695 5.2959C11.0695 3.83263 12.2781 2.62402 13.7413 2.62402ZM13.7413 12.9668C12.9167 12.9668 12.2044 13.6505 12.2042 14.5029C12.2042 15.3569 12.8874 16.04 13.7413 16.04C14.5951 16.0398 15.2775 15.3567 15.2775 14.5029C15.2773 13.6493 14.595 12.967 13.7413 12.9668ZM4.53333 8.36328C3.67939 8.36328 2.99622 9.04548 2.99622 9.89941C2.99622 10.7533 3.67939 11.4355 4.53333 11.4355C5.38717 11.4354 6.06946 10.7533 6.06946 9.89941C6.06946 9.04554 5.38717 8.36338 4.53333 8.36328ZM13.7413 3.75879C12.9166 3.75879 12.2042 4.44328 12.2042 5.2959C12.2044 6.14964 12.8875 6.83203 13.7413 6.83203C14.595 6.83184 15.2773 6.14952 15.2775 5.2959C15.2775 4.44208 14.5951 3.75898 13.7413 3.75879Z"
                            fill="white"
                            stroke="white"
                            strokeWidth="0.22"
                          />
                        </svg>
                      </span>
                    </div>
                  </div>
                </div>
                {item?.tag !== "0" && (
                  <div className={slider.dramsHot}>
                    <span>{tags[item.tag || "0"]}</span>
                  </div>
                )}
              </div>
              <div className={slider.dramaName}>
                <Link href={`/drama/${createSlug(item.drama_name)}-${item.id}/?episode=0`}>{item.drama_name}</Link>
              </div>
              {/* </div> */}
            </SwiperSlide>
          );
        })}
    </Swiper>
  );
};

export default Slider;
